import { jsx } from "react/jsx-runtime";
const ClearAllIcon = (props) => /* @__PURE__ */ jsx("svg", { ...props, viewBox: "0 0 1024 1024", children: /* @__PURE__ */ jsx("path", { d: "m752 240h-608c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32v-608c0-17.7-14.3-32-32-32zm-40 600h-528v-528h528zm168-728h-616c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-616c0-17.7-14.3-32-32-32zm-580 438h296v64h-296z" }) });
export {
  ClearAllIcon
};
